import React, { useEffect, useState } from 'react';
import Sidebar from '../components/Sidebar';
import Navbar from '../components/Navbar';
import './dashboard.css';
import { useSearchParams } from 'react-router-dom';
import Swal from 'sweetalert2';
import { editMember, getByMemberId } from '../store/slices/userSlice'; // Keep getByMemberId if used elsewhere
import { usStates } from '../services/states';
import { useDispatch } from 'react-redux'; // Import useDispatch
import { Form } from 'react-bootstrap'; // Assuming you are using react-bootstrap

function Myprofile() {
  const [searchParams] = useSearchParams();
  const [id, setId] = useState(null);
  const [loading, setLoading] = useState(true);
  const dispatch = useDispatch(); // Initialize useDispatch

  // State to hold all form data
  const [formData, setFormData] = useState({
    mobile: '',
    firstname: '',
    lastname: '',
    addressline1: '',
    addressline2: '',
    addressline3: '',
    state: '',
    zipcode: '',
    email: '',
    validupto: '',
  });

  // Handle changes for all form inputs
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  useEffect(() => {
    const loadUserData = () => {
      try {
        const localId = localStorage.getItem('id');
        if (localId) {
          setId(localId);
          console.log(localStorage.getItem('userData'));
  
          const userData = JSON.parse(localStorage.getItem('userData') || '{}');
  
          if (userData) {
            setFormData({
              mobile: userData.mobile || '',
              firstname: userData.firstname || '',
              lastname: userData.lastname || '',
              addressline1: userData.addressline1 || '',
              addressline2: userData.addressline2 || '',
              addressline3: userData.addressline3 || '',
              state: userData.state || '',
              zipcode: userData.zipcode || '',
              email: userData.email || '',
              validupto: userData.validupto || '',
            });
          }
        }
      } catch (error) {
        console.error("Error loading user data from localStorage:", error);
        Swal.fire('Error', 'Failed to load user data from storage.', 'error');
      } finally {
        setLoading(false);
      }
    };
  
    loadUserData();
  }, [searchParams]);
  
  const handleProfileUpdate = async (e) => {
    e.preventDefault();

    const { mobile, firstname, lastname, addressline1 } = formData;

    // Basic validation
    if (!mobile || !firstname || !lastname || !addressline1) {
      Swal.fire('Error', 'Please fill in all required fields (Mobile, First Name, Last Name, Address Line 1)', 'error');
      return;
    }

    // JS validation for 10-digit phone number
    if (!/^\d{10}$/.test(mobile)) {
      Swal.fire('Error', 'Mobile number must be exactly 10 digits.', 'error');
      return;
    }

    try {
      const payload = { id, ...formData }; // Use spread operator to include all formData
      // Assuming editMember is a redux action or API call function
      const response = await dispatch(editMember(payload)); // Dispatch the action

      if (response?.payload?.status === 200) { // Access payload if it's a Redux fulfilled action
        Swal.fire('Success', 'Profile updated successfully!', 'success');
        // Optionally update localStorage or redux state here
        localStorage.setItem(
          'userData',
          JSON.stringify({ id, ...formData }) // Store all updated formData
        );
      } else {
        Swal.fire('Error', 'Failed to update profile', 'error');
      }
    } catch (error) {
      console.error('Error updating profile:', error);
      Swal.fire('Error', 'Something went wrong!', 'error');
    }
  };

  return (
    <div>
      <Navbar />
      <Sidebar />

      {loading ? (
        <div className="preloader">
          <div className="lds-ripple">
            <div className="lds-pos"></div>
            <div className="lds-pos"></div>
          </div>
        </div>
      ) : (
        <div id="main-wrapper">
          <div className="page-wrapper d-block">
            <div className="body-wrapper">
              <div className="container-fluid">
                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }} className="mb-4">
                  <h3 className="mb-0">Update Profile</h3>
                  <a href="/renewmembership">
                    <button
                      className="btn btn-info btn-sm"
                      style={{ minWidth: 130 }}
                    >
                      Renew Membership
                    </button>
                  </a>
                </div>

                <form onSubmit={handleProfileUpdate} className="mb-5">
                  {/* First Name */}
                  <div className="mb-3">
                    <label className="form-label">First Name</label>
                    <input
                      type="text"
                      className="form-control"
                      name="firstname"
                      value={formData.firstname}
                      onChange={handleChange}
                      required
                    />
                  </div>

                  {/* Last Name */}
                  <div className="mb-3">
                    <label className="form-label">Last Name</label>
                    <input
                      type="text"
                      className="form-control"
                      name="lastname"
                      value={formData.lastname}
                      onChange={handleChange}
                      required
                    />
                  </div>

                  {/* Mobile */}
                  <div className="mb-3">
                    <label className="form-label">Mobile</label>
                    <input
                      type="tel"
                      className="form-control"
                      name="mobile"
                      value={formData.mobile}
                      onChange={handleChange}
                      required
                      pattern="[0-9]{10}"
                      title="Enter a valid 10-digit mobile number"
                    />
                  </div>

                  {/* Membership Valid Upto */}
                  <div className="mb-3">
                    <label className="form-label">Membership Valid Upto</label>
                    <input
                      type="date"
                      className="form-control"
                      name="validupto"
                      value={formData.validupto}
                      onChange={handleChange}
                      readOnly
                    />
                  </div>

                  {/* Address Line 1 */}
                  <div className="mb-3">
                    <label className="form-label">Address Line 1</label>
                    <textarea
                      className="form-control"
                      name="addressline1"
                      value={formData.addressline1}
                      onChange={handleChange}
                      rows={3}
                      required
                    />
                  </div>

                  {/* Address Line 2 */}
                  <div className="mb-3">
                    <label className="form-label">Address Line 2</label>
                    <textarea
                      className="form-control"
                      name="addressline2"
                      value={formData.addressline2}
                      onChange={handleChange}
                      rows={3}
                    />
                  </div>

                  {/* Address Line 3 */}
                  <div className="mb-3">
                    <label className="form-label">Address Line 3</label>
                    <textarea
                      className="form-control"
                      name="addressline3"
                      value={formData.addressline3}
                      onChange={handleChange}
                      rows={3}
                    />
                  </div>

                  {/* State */}
                  <Form.Group className="mb-3" controlId="state">
                    <Form.Label style={{ fontSize: "10px" }}>State</Form.Label>
                    <Form.Control
                      as="select"
                      style={{ width: "95%", fontSize: "10px", color: "gray" }}
                      name="state"
                      value={formData.state}
                      onChange={handleChange}
                    >
                      <option value="">Select State</option>
                      {usStates.map((state) => (
                          <option key={state.abbreviation} value={state.abbreviation}>
                            {state.name} ({state.abbreviation})
                          </option>
                        ))}
                    </Form.Control>
                  </Form.Group>

                  {/* Zip Code */}
                  <Form.Group className="mb-3" controlId="zipcode">
                    <Form.Label style={{ fontSize: "12px" }}>Zip Code</Form.Label>
                    <Form.Control
                      type="tel"
                      name="zipcode"
                      value={formData.zipcode}
                      onChange={handleChange}
                      required
                      style={{ fontSize: "12px" }}
                    />
                  </Form.Group>

                  {/* Email (Uneditable) */}
                  <div className="mb-3">
                    <label className="form-label">Email (Uneditable)</label>
                    <input
                      type="email"
                      className="form-control"
                      name="email"
                      value={formData.email}
                      disabled
                      readOnly
                    />
                  </div>

                  <button type="submit" className="btn btn-primary">
                    Update Profile
                  </button>
                </form>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default Myprofile;